import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { generateFormId } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { IAccount } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { MultiStepForm } from "@rentiohq/web-shared/dist/components";
import linkContactSchema from "forms/linkContact";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  submitActionCreator,
} from "forms/linkContact/schema.linkContact.actions";
import React from "react";

interface IProps {
  contact: IContact | IAccount;
  onClose: () => void;
  refetchProperty: () => void;
}

export const LinkContact = (props: IProps) => {
  const { onClose, contact, refetchProperty } = props;
  const [formId] = React.useState(generateFormId());
  // @ts-ignore
  const idToLink = contact?.accountId || contact.id;

  return (
    <MultiStepForm
      formId={`link-contact-${formId}`}
      schemas={linkContactSchema()}
      asModal={true}
      withAside={false}
      isPerformingSubmitActionSelector={isPerformingSubmitActionSelector}
      performingSubmitActionErrorSelector={performingSubmitActionErrorSelector}
      submitActionCreator={formData => submitActionCreator(formData, idToLink)}
      modalProps={{
        onClose,
        heading: getLocalizedText("link_contact.modal.heading", {
          contact: getName(contact),
        }),
        width: "medium",
      }}
      onSuccess={() => {
        refetchProperty();
        onClose();
      }}
      submitLabel={getLocalizedText("contact.action.link.label")}
    />
  );
};
